import { createSlice } from "@reduxjs/toolkit";

export const surveyCategoryLists = createSlice({
  name: "surveyCategoryLists",
  initialState: null,
  reducers: {
    setsurveyCategoryLists: (state, action) => {
      return (state = action.payload);
    },
  },
});

export const { setsurveyCategoryLists } = surveyCategoryLists.actions;

export default surveyCategoryLists.reducer;
